import {
  ChakraCard as Card,
  ChakraCardBody as CardBody,
  ChakraBox as Box,
  ChakraImage as Image,
  ChakraVStack as VStack,
  ChakraHeading as Heading,
  ChakraText as Text,
} from "@airhelp/react-ui-components";
import { useDeviceSize } from "hooks";
import isEmpty from "modules/storyblok/adapters/RichtextAdapter/utils/isEmpty";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { contentStyles } from "./TeamCard.styles";
import type { TeamCardProps } from "./TeamCard.d";
import { LinkedInCircle } from "../LinkedInCircle";

export const TeamCard = ({ imageSrc, name, position, description }: TeamCardProps) => {
  const { isMobile } = useDeviceSize();
  const headingVariant = isMobile ? "h3" : "h4";
  return (
    <Card maxW={{ base: "288px", md: "311px" }} variant="unstyled" overflow="hidden">
      <Image src={imageSrc} alt={name} w="100%" objectFit="cover" />
      <Box ml={4} w="fit-content" mt="-22px" borderRadius="full" overflow="hidden">
        <LinkedInCircle width="44px" height="44px" />
      </Box>
      <CardBody px={{ base: 4, lg: 6 }} pb={{ base: 4, lg: 12 }} pt={{ base: 4, lg: 5 }}>
        <VStack align="left" spacing={2}>
          <Heading variant={headingVariant} as={headingVariant} fontWeight="bold">
            {name}
          </Heading>
          <Text fontSize="sm" fontWeight="medium" color="greyscale.600">
            {position}
          </Text>
          {!isEmpty(description) && <RichtextAdapter content={description} customStyles={contentStyles} />}
        </VStack>
      </CardBody>
    </Card>
  );
};
